import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { useDispenseAssets } from '@/hooks/useDispenseAssets';

import type { CassetteView } from '@/types/generated/athena';

type Props = {
  cassette: CassetteView;
  onChange: (_: CassetteView) => void;
};

const LoadOrderAdjustmentCard = ({ cassette, onChange }: Props) => {
  const { cassette_index, bill_note_id, count: current } = cassette;
  const isEmpty = !bill_note_id;
  const [count, setCount] = useState<number>(0);
  const { billsMap } = useDispenseAssets();

  useEffect(() => onChange({ ...cassette, count }), [count]);

  return (
    <Card sx={{ height: '100%' }}>
      <Stack p={2} height="100%">
        <Stack mb={2} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="overline" sx={{ borderLeft: '4px solid red', pl: 2 }}>
            Cassette {cassette_index}
          </Typography>
        </Stack>
        {isEmpty && (
          <Stack
            justifyContent="center"
            bgcolor="neutral.50"
            textAlign="center"
            borderRadius={1}
            flex={1}
            p={2}
          >
            <Typography variant="caption" color="text.secondary">
              Expected Count
            </Typography>
            <Typography variant="overline" lineHeight={2} fontSize={14}>
              Empty
            </Typography>
          </Stack>
        )}
        {!isEmpty && (
          <Stack gap={2}>
            <Stack direction="row">
              <Box flex={1}>
                <Typography variant="body2" color="text.secondary">
                  Asset
                </Typography>
                <Typography variant="body1">
                  {billsMap[bill_note_id]?.at(0) ?? '-'} ({billsMap[bill_note_id]?.at(1) ?? '-'})
                </Typography>
              </Box>
              <Box flex={1} textAlign="right">
                <Typography variant="body2" color="text.secondary">
                  Current Count
                </Typography>
                <Typography variant="body1">{current}</Typography>
              </Box>
            </Stack>

            <Stack direction="row" alignItems="center" bgcolor="neutral.50" p={2} borderRadius={1}>
              <Button variant="contained" color="secondary" onClick={() => setCount(count - 1)}>
                -
              </Button>
              <Typography variant="h5" textAlign="center" flex={1}>
                {count}
              </Typography>
              <Button variant="contained" onClick={() => setCount(count + 1)}>
                +
              </Button>
            </Stack>
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default LoadOrderAdjustmentCard;
